
export default {
    data() {
        return {
            nav: 0,
            source: '',
            currentPage: 1,
            joy: 0,
            Sadness: 0,
            activityId: 15,
            sidebar: 'en'
        }
    },
    mounted() {
        this.parametricWork()
    },
    methods: {
        checlin(index) {
            this.nav = index
        },
        // 作品方法
        async parametricWork(page = 1) {
            let res = await this.$global.parametricWork({ "activityId": this.activityId, "page": page, "award": 0 })
            console.log(res);
            // res.code = '200' ? (this.source = res.result) : []
            this.source = res
        },
        // 分页
        handleCurrentChange(val) {
            this.currentPage = val
            this.parametricWork(this.currentPage)
        },
        changeLanguage(lang) {
            this.sidebar = lang
            this.$loadLanguageAsync(lang)
        }
    },
    watch: {
        sidebar: {
            handler: function (val) {
                switch (val) {
                    case 'jp':
                        this.$i18n.locale = 'jp'
                        break;
                    case 'en':
                        this.$i18n.locale = 'en'
                        break;
                    case 'kr':
                        this.$i18n.locale = 'kr'
                        break;
                    case 'de':
                        this.$i18n.locale = 'de'
                        break;
                    case 'fr':
                        this.$i18n.locale = 'fr'
                        break;
                    case 'it':
                        this.$i18n.locale = 'it'
                        break;
                    case 'es':
                        this.$i18n.locale = 'es'
                        break;
                    case 'br':
                        this.$i18n.locale = 'br'
                        break;
                    case 'ru':
                        this.$i18n.locale = 'ru'
                        break;
                    case 'yn':
                        this.$i18n.locale = 'yn'
                        break;
                    case 'jk':
                        this.$i18n.locale = 'jk'
                        break;
                    default:
                        break;
                }
            },
            deep: true,
            immediate: true
        },
        Sadness: {
            handler(val) {
                console.log(val);
                this.currentPage = 1
                this.source = null
                if (val == 0) {
                    this.activityId = 15
                    this.parametricWork()
                } else {
                    this.activityId = 16
                    this.parametricWork()
                }

            }
        }
    }
}
